// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/index.js";
import axios from "axios";
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/resetui.css'
import Qs from "qs";
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'babel-polyfill'
import PinchZoom from 'vue-pinch-zoom';
import JSONbig from "json-bigint"
import {description} from '../package.json'
import eventBus from '@/assets/js/eventBus.js'
Vue.component('pinch-zoom', PinchZoom);

Vue.use(Vant);
Vue.use(VueMoment, {
  moment,
});

Vue.config.productionTip = false;
axios.defaults.transformRequest = [function (data) {
  if (data.toString() == "[object FormData]") {
    return data;
  } else {
    return Qs.stringify(data)
  }
}];
axios.defaults.transformResponse=[(data) => {
  if (typeof data === 'string') {
    try {
      data = JSONbig.parse(data);
    } catch (e) { /* Ignore */ } // Added this Ignore as it's the same in the Axios
  }
  return data;
}];
// const host = process.env.NODE_ENV === "development" ? "http://api.stock.com/" : "https://pc_apiserver5618.hk9999.com/"; // 根据 process.env.NODE_ENV 的值判断当前是什么环境
console.log("build :",description);
let lineURL = localStorage.getItem('lineUrl');

let initApp = function () {
  const instance = axios.create({
    baseURL: localStorage.lineUrl,
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$http = instance;

  sessionStorage.removeItem('lineUrl')
    //force logout and goto login
    Vue.prototype.$logout = function (msg) {
      this.$toast.fail(msg);
      setTimeout(() => {
        this.$store.commit("changeLoginType", false);
        sessionStorage.setItem("token", "");
        localStorage.clear();
        this.$router.push("/login");
        window.location.reload();
      }, 2000);
    };
  
    // Common loader
    Vue.prototype.$NoNetworkErrorMsg = "网络连接失败,稍后再试";
    Vue.prototype.$ShowCommonLoading = function () {
      return this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        overlay: true,
        message: "加载中...",
      });
    };

    Vue.prototype.$LoadFromDomain = process.env.LOAD_FROM_DOMAIN;
    Vue.prototype.$appDownloadPromotion = process.env.APP_DOWNLOAD_PROMOTION;
    Vue.prototype.$eventBus = eventBus;
  
    new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
    });
    router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
}

/**
 * wonder chat system start
 */

const wonderChatInstace = axios.create({
  baseURL: process.env.WONDER_CHAT_ROOT,
  timeout: 10000,
  withCredentials: true
});
Vue.prototype.$wonderChat = wonderChatInstace;

//end wonder chat system
//Vue.prototype.$http = instance;

Vue.prototype.$chatApiURL = process.env.WONDER_CHAT_ROOT;//"https://chat.hk99555.com/";

let Line_1 = process.env.Line_1;//"https://server3299.hk99666.com/";
let Line_2 = process.env.Line_2;//"https://server3299.hk99111.com/";



Vue.prototype.$URLs = [{ "id": 1, "name": "线路 1", "url": process.env.API_ROOT }, { "id": 2, "name": "线路 2", "url": Line_1 }, { "id": 3, "name": "线路 3", "url": Line_2 }];

let lines = Vue.prototype.$URLs;
  
  let workingLines = [];
  
  let checkLine = function (url) {
    return new Promise((resolve, reject) => {
     if(url === null || url === undefined){reject();return;};
      fetch(url, { mode: 'no-cors' })
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject();
        });
    });
  }
  
  let lineSelectPromise = new Promise((resolve, reject) => {
    lines.forEach((value, index, array) => {
      let startTime = new Date().getTime();
      fetch(value.url, { mode: 'no-cors' })
        .then(response => {
          let endTime = new Date().getTime();
          let elapsedTime = endTime - startTime;
          let item = {};
          item.time = elapsedTime;
          item.url = value.url;
  
          workingLines.push(item);
          if (index === array.length - 1 || workingLines.length > 1) resolve();
  
        })
        .catch(error => {
          if (index === array.length - 1) resolve();
        });
    })
  })
  
  //continue with current api line if it's working
  let storedLine = sessionStorage.lineUrl;
  checkLine(storedLine).then(() => {
    initApp();
  }).catch(() => {

    lineSelectPromise.then(res => {
            setTimeout(() => {
      console.log(workingLines);     
       workingLines.sort((a, b) => (a.time > b.time) ? 1 : -1)
      console.log(workingLines.length);         
      localStorage.setItem('lineUrl',workingLines[0].url);
      sessionStorage.setItem('lineUrl',workingLines[0].url);
      initApp();
    },1000);
    
      // let lineURL='';
      // if(workingLines.length > 0){
      //   lineURL=workingLines[0].url
      // }
      // else{
      //   workingLines.forEach((item) => {
      //     console.log(item);
      //     lineURL=item.url
      //   });
      //   // console.log("url"+item);

      // }
      // console.log("lineurl"+workingLines[0].url);
      // if (lineURL) {
      //   localStorage.setItem('lineUrl', lineURL);
      //   sessionStorage.setItem('lineUrl',lineURL);
      // } else {
      //   localStorage.setItem('lineUrl',process.env.API_ROOT);
      //   sessionStorage.setItem('lineUrl',process.env.API_ROOT);
      // }
    })
  })



// WEBPACK FOOTER //
// ./src/main.js